var Component = require("!../../../vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../vue-loader/lib/selector?type=script&index=0!./HeadSort.vue"),
  /* template */
  require("!!../../../vue-loader/lib/template-compiler?id=data-v-5b7213c6!../../../vue-loader/lib/selector?type=template&index=0!./HeadSort.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/vue2-datatable-component/src/Table/HeadSort.vue
// module id = 1214
// module chunks = 2